module.exports = __webpack_public_path__ + "media/images/lb/285-5640387c7f198f75c815bcc0ebf00af3.svg";